import axios, { AxiosResponse, AxiosInstance } from 'axios';
import { OrganizerAPI } from '@/apis';
import WDOperatorModel from '@/models/WDOperatorModel';
import { TagModel } from '@/models/TagModel';

export class OperatorService {

  private static internal: OperatorService = new OperatorService(OrganizerAPI.instance);

  public static get instance(): OperatorService {
    return OperatorService.internal;
  }

  constructor(private api: AxiosInstance) { }


  public getOperatorsByEvent(eventId: number, tagList: TagModel[]): Promise<WDOperatorModel[]> {
    return this.api.get(`/events/${eventId}/operators/`).then((response: AxiosResponse<any[]>) => {
      return response.data.map((rawOperator: any): WDOperatorModel => {
        const operator = new WDOperatorModel({
          ...rawOperator,
          tags: rawOperator.tags.map((tagId: number) => {
            const tag = tagList.find(t => t.id === tagId);
            return tag ? tag : { id: tagId, name: "Inconnu" } as TagModel;
          })
        });
        return operator;
      });
    });
  }


  /**
   * Crée un opérateur pour un événement spécifique
   * @param operator Les données de l'opérateur
   */
  public createOperator(operator: WDOperatorModel, eventId: number): Promise<WDOperatorModel> {
    return this.api.post<WDOperatorModel>(`/events/${eventId}/operators/`, operator.toJSON())
      .then((response: AxiosResponse<WDOperatorModel>) => {
        return new WDOperatorModel(response.data);
      });
  }

  /**
   * Met à jour un opérateur existant
   * @param operator Les données de l'opérateur
   */
  public updateOperator(operator: WDOperatorModel): Promise<WDOperatorModel> {
    return this.api.put<WDOperatorModel>(`/operators/${operator.id}/`, operator.toJSON())
      .then((response: AxiosResponse<WDOperatorModel>) => {
        return new WDOperatorModel(response.data);
      });
  }

  /**
   * Supprime un opérateur d'un événement spécifique
   * @param eventId L'identifiant de l'événement
   * @param operatorId L'identifiant de l'opérateur
   */
  public deleteOperator(operator: WDOperatorModel): Promise<void> {
    return this.api.delete(`/operators/${operator.id}/`);
  }
}
